export interface NewVideoTagProps {
  isNew: boolean;
}

export const NewVideoTag = (props: NewVideoTagProps) => {
  const { isNew } = props;
  if (!isNew) return null;
  return (
    <span className="absolute top-[8px] left-[8px] z-10 px-[4px] text-[10px] font-semibold text-white bg-kds-danger rounded-full leading-[14px]">
      New
    </span>
  );
};
